export let fabricConsumptionProps = {
    key: 0,
    fabric_width_list: []  
}

export let dataProps = {
    id: 0,
    size_name: '',
    tailoring_category_id: 0,

    fabric_consumption_list: [JSON.parse(JSON.stringify(fabricConsumptionProps))],
    delete_fabric_consumption_list: [],
}


// WEBPACK FOOTER //
// ./src/store/modules/tailoringSize/properties.js